export default __webpack_public_path__ + "4c85ff195227438c74b482232318585d.png";